


































import { Vue, Component } from "vue-property-decorator";
import type { IUGCImageErrorModal } from "./Globals/types/ugc.t";
import CustomContainer from './Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import UgcImageError from '@/components/molecule.modal.ugcImageError.vue';
import CustomButton from '@/components/Globals/CustomButton.vue';
import ugcImageUpload from '@/components/UGC/Tray/ImageUpload';

@Component({
  components: {
    CustomContainer,
    CustomModal,
    CustomButton,
    ModalHeader,
    UgcImageError,
    ugcImageUpload
  },
  name: 'ugcUploadImageError'
})
export default class UgcUploadImageError extends Vue {

  public imageRequirements: IUGCImageErrorModal = {};

  closeAction() {
    this.$modal.hide('ugcUploadImageErrorModal');
  }

  onCTAAction() {
    this.$modal.hide('ugcUploadImageErrorModal');
  }

  beforeOpenModal(data: any){
    const { params } = data;
    if(params) {
      this.imageRequirements = params;
    }
  }

  get translations() {
    return this.$store.state.translations?.data;
  }

}
